/**
 * Reads the csrf_token cookie (deliberately non-httpOnly, see issueAuthCookies in server.ts)
 * to send it back as the X-CSRF-Token header on every mutation, the "double submit cookie"
 * pattern. It's not a secret: it only proves that the caller can read cookies from this
 * origin, something an attacking site on another origin cannot do.
 */
export function getCsrfToken(): string {
  const match = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}
